import NavFurtherAction from './nav-further-action';
import { USER_TYPE_REP, USER_TYPE_RETAILER } from '../../../data/userTypes';

const NavBarFooter = ({ type = USER_TYPE_RETAILER }) => {
  const uriPrefix = type === USER_TYPE_REP ? '/team' : '';

  return (
    <div className={'footer no-logo'} id="navbar-footer">
      <div className="nav-further-actions">
        <NavFurtherAction href={`${uriPrefix}/my-profile`} icon="user" tooltip="My Profile"/>
        <NavFurtherAction href={`${uriPrefix}/content-pages/terms-conditions`} icon="edit" tooltip="Terms & Conditions"/>
        <NavFurtherAction href={`${uriPrefix}/about-ignite`} icon="question" tooltip="FAQs"/>
        <NavFurtherAction href={`${uriPrefix}/content-pages/privacy-policy`} icon="eye" tooltip="Privacy Policy"/>
      </div>
    </div>
  );
};

export default NavBarFooter;
